<template>
  <section v-if="contextData">
    <div class="container-wrap py-9 tablet:py-12">
      <h2 class="text-solution-h2 mb-2 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>
      <p
        class="mb-6 w-full text-sm text-gray-600 tablet:mb-8 tablet:line-clamp-3 tablet:text-base desktop:mb-6 desktop:w-2/3"
      >
        {{ contextData.description }}
      </p>

      <ul :class="provideItemsClass">
        <li
          v-for="item in contextData.items"
          :key="hash(item)"
          class="mb-3 w-full rounded bg-gradient-to-t from-green-400 to-blue-400 p-3 text-white last:mb-0 tablet:mb-0 tablet:p-4 desktop:p-5"
        >
          <h3
            v-if="item.name"
            class="mb-2 text-base font-bold leading-7 tablet:line-clamp-1 tablet:text-lg desktop:text-xl"
          >
            {{ item.name }}
          </h3>
          <div class="mb-2 flex justify-between">
            <div class="flex-1">
              <p class="line-clamp-1 w-full">
                <strong
                  class="pr-1 text-[1.75rem] leading-9 tablet:text-[2rem] tablet:leading-[2.75rem] desktop:text-5xl desktop:leading-[3.5rem]"
                >
                  {{ item.value?.toFixed(1) }}
                </strong>
                <sub class="text-solution-h2 align-super">
                  {{ item.unit }}
                </sub>
              </p>
            </div>
            <IconArrow
              class="h-9 w-9 basis-9 text-white tablet:h-11 tablet:w-11 tablet:basis-11 desktop:h-14 desktop:w-14 desktop:basis-14"
              :direction="item.isUpArrow ? 'up' : 'down'"
            />
          </div>
          <p class="text-sm tablet:line-clamp-[7]">
            {{ item.description }}
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    value: number;
    unit: string;
    isUpArrow: boolean;
    description?: string;
  }

  interface IListIndicatorData {
    title: string;
    description?: string;
    numberOfLine: 2 | 3 | 4;
    items: IItem[];
  }

  interface IListIndicator {
    component: 'list-indicator';
    meta: {
      navigable?: string;
    };
    data: IListIndicatorData;
  }

  type IProps = ISuiteProps<IListIndicator>;

  const props = defineProps<IProps>();

  const contextData = computed((): IListIndicatorData => props.suiteData.data);

  const provideItemsClass = computed((): string => {
    switch (contextData.value.numberOfLine) {
      case 2:
        return 'column-221';
      case 3:
        return 'column-331';
      case 4:
        return 'column-421';
      default:
        return '';
    }
  });

  export type { IItem, IListIndicator, IListIndicatorData };
</script>
